/**
 * Constants for the businesses feature
 */

export const SERVICE_OPTIONS = [
  'residential',
  'commercial',
  'deep_cleaning',
  'move_out',
  'office_cleaning',
  'post_construction',
  'carpet_cleaning',
  'window_cleaning'
] as const;

const BUSINESS_TYPES = {
  INDEPENDENT_CONTRACTOR: 'independent_contractor',
} as const;

export const BUSINESS_TYPE_OPTIONS = [
  { value: BUSINESS_TYPES.INDEPENDENT_CONTRACTOR, label: 'Independent Contractor' }
] as const;

export const BUSINESS_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
} as const;

export const DAYS_OF_WEEK = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
] as const;

/**
 * Formats a service option string into a human-readable label
 * @param service - The service option to format
 * @returns Formatted service name
 */
export function formatServiceName(service: string): string {
  return service.split('_').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');
}

/**
 * Formats a day of week string for display
 * @param day - The day to format
 * @returns Capitalized day name
 */
export function formatDayName(day: string): string {
  return day.charAt(0).toUpperCase() + day.slice(1);
}
